module.exports = __webpack_public_path__ + "static/media/Shabnam-Bold.611e8cd4.woff";